/* BG COM catalogue : logique du filtre de catégorie unifié des collections (spec coll/wf1/SPEC.md, 30/09/2026).
   04/10/2026 (vitesse r5.1) : sorti de snippets/bgcom-mc-2 (63 Ko en ligne sur chaque collection) vers cet asset en defer, mis en
   cache d'une collection à l'autre. Les 4 valeurs Liquid viennent de window.BgcomFilterCfg (snippets/bgcom-mc-1 : sectionId, page,
   totalPages). Exécuté juste avant DOMContentLoaded (readyState 'interactive') : initBgcomApp tourne tout de suite, comme avant à
   DOMContentLoaded, et toujours avant le renderer de prix (samita-custom, DOMContentLoaded). */
(function() {
  function initBgcomApp() {
    const isDesignMode = window.Shopify && window.Shopify.designMode;

    window.bgcomForceRevealPrices = false;
    window.bgcomWholesaleData = window.bgcomWholesaleData || {};

    function formatEUR(cents) {
        let euros = (cents / 100).toFixed(2);
        euros = euros.replace('.', ',');
        return '€' + euros;
    }

    function getLowestPriceFromContainer(container) {
        let elements = container.querySelectorAll('.money');
        if (elements.length === 0) elements =[container]; 
        
        let lowest = Infinity;
        elements.forEach(el => {
            let text = el.innerText.replace(/\d+\s*%/g, ''); 
            const regex = /\d{1,3}(?:[ .\s]\d{3})*(?:[.,]\d{2})?(?!\d)/g;
            const matches = text.match(regex);
            if (matches) {
                for (let m of matches) {
                    let clean = m.replace(/[^0-9.,]/g, '');
                    if (!clean) continue;
                    let cents = clean.match(/[.,]\d{2}$/) ? parseInt(clean.replace(/[^0-9]/g, ''), 10) : parseInt(clean.replace(/[^0-9]/g, ''), 10) * 100;
                    if (cents > 100 && cents < lowest) lowest = cents;
                }
            }
        });
        return lowest === Infinity ? null : lowest;
    }

    function processSamitaBadges(forceReveal = false) {
        /* ════════════════════════════════════════════════════════════
           DISABLED — catalogue price rendering is now handled solely
           by bgcomRenderCatalogueTarget (snippets/samita-custom.liquid).
           Running this second renderer in parallel caused:
             • false wholesale discounts leaking to guests
             • a residual flicker from two renderers fighting over the
               same .bgcom-samita-target containers
           This function is kept only as a safety reveal so prices are
           never stuck hidden if the main renderer hasn't run yet.
           ════════════════════════════════════════════════════════════ */
        if (forceReveal) {
            document.querySelectorAll('.bgcom-card-wrap .bgcom-samita-target').forEach(function (t) {
                if (!t.dataset.bgcomState) t.classList.add('bgcom-price-ready');
            });
        }
        return;

        /* eslint-disable no-unreachable */
        document.querySelectorAll('.bgcom-card-wrap').forEach(card => {
            const targetContainer = card.querySelector('.bgcom-samita-target');
            if (!targetContainer) return;

            const origPriceHT = parseInt(card.getAttribute('data-price'), 10);
            const ttcContainer = targetContainer.querySelector('[data-samita-ttc]');
            const htContainer = targetContainer.querySelector('[data-samita-ht]');
            if (!ttcContainer) return;

            let wholesaleHT = null;

            const pId = card.getAttribute('data-product-id');
            if (window.bgcomWholesaleData && window.bgcomWholesaleData[pId]) {
                wholesaleHT = window.bgcomWholesaleData[pId];
            }

            const domPriceHT = getLowestPriceFromContainer(ttcContainer);
            if (domPriceHT && domPriceHT < origPriceHT && (!wholesaleHT || domPriceHT < wholesaleHT)) {
                wholesaleHT = domPriceHT;
            }

            let discountApplied = false;

            if (wholesaleHT && wholesaleHT < origPriceHT) {
                discountApplied = true;
                if (!ttcContainer.querySelector('.bgcom-discount-badge')) { 
                    const discountPct = Math.round((1 - (wholesaleHT / origPriceHT)) * 100);
                    const wholesaleTTC = Math.round(wholesaleHT * 1.2);

                    ttcContainer.innerHTML = `<span class="money">${formatEUR(wholesaleTTC)}</span> TTC <span class="bgcom-discount-badge">-${discountPct}%</span>`;
                    
                    if (htContainer) {
                        htContainer.innerHTML = `<span class="money">${formatEUR(wholesaleHT)}</span> HT <span class="bgcom-original-price"><s>${formatEUR(origPriceHT)} HT</s></span>`;
                    }
                }
            }

            if (!targetContainer.classList.contains('bgcom-price-ready')) {
                if (discountApplied || forceReveal) {
                    targetContainer.classList.add('bgcom-price-ready');
                }
            }

            const sku = card.getAttribute('data-sku');
            const cachedItem = allProductsCache.find(item => item.sku === sku);
            if (cachedItem) { 
                if (wholesaleHT && wholesaleHT < origPriceHT) {
                    cachedItem.price = wholesaleHT;
                }
                if (cachedItem.html !== card.outerHTML) {
                    cachedItem.html = card.outerHTML; 
                }
            }
        });
    }

    setTimeout(() => {
        window.bgcomForceRevealPrices = true;
        processSamitaBadges(true);
    }, 2500);

    if (!window.bgcomSamitaListenerAttached) {
        document.addEventListener('Samita.Wholesale.product.updated', function (e) {
            const data = e.detail || {};
            let items =[];
            if (Array.isArray(data)) items = data;
            else if (data.products && Array.isArray(data.products)) items = data.products;
            else if (data.product_id || data.id || (data.product && data.product.id)) items =[data];
            else if (typeof data === 'object') {
                Object.keys(data).forEach(k => { if (!isNaN(k)) items.push({ id: k, price: data[k] }); });
            }

            items.forEach(p => {
                const pId = p.product_id || p.id || (p.product && p.product.id);
                let newPrice = p.price || p.wholesale_price || p.discounted_price || p.calculated_price;
                if (pId && newPrice) {
                    if (newPrice < 10000 && newPrice.toString().includes('.')) {
                        newPrice = Math.round(parseFloat(newPrice) * 100);
                    }
                    window.bgcomWholesaleData[pId.toString()] = newPrice;
                }
            });
            clearTimeout(window.bgcomGridSamitaDebounce);
            window.bgcomGridSamitaDebounce = setTimeout(() => processSamitaBadges(false), 20);
        });
        window.bgcomSamitaListenerAttached = true;
    }

    const gridObserver = new MutationObserver((mutations) => {
        let shouldProcess = false;
        mutations.forEach(m => {
            if (m.type === 'characterData' || m.type === 'childList') shouldProcess = true;
        });
        if (shouldProcess) {
            clearTimeout(window.bgcomGridSamitaDebounce);
            window.bgcomGridSamitaDebounce = setTimeout(() => processSamitaBadges(false), 20);
        }
    });
    
    const originalGrid = document.getElementById('BgcomOriginalGrid');
    const searchGrid = document.getElementById('BgcomSearchGrid');
    if (originalGrid) gridObserver.observe(originalGrid, { childList: true, subtree: true, characterData: true });
    if (searchGrid) gridObserver.observe(searchGrid, { childList: true, subtree: true, characterData: true });

    /* ════════════════════════════════════════════════════════════════════════
       BG COM filtre de catégorie unifié (spec coll/wf1/SPEC.md, 30/09/2026)
       Un état {l2, l3, l4, q, stock, sort} ; une fonction render() ; l'état vit dans l'URL.
       Liens (décision SEO du 30/09, prime sur la spec) : tuiles et cartes gardent l'adresse du menu
       (/collections/x/Etiquette, écrite par Liquid, jamais réécrite ici). Un clic simple est intercepté : filtre sur
       place + pushState vers cette même adresse (le niveau le plus fin choisi). Recherche, stock et tri : ?q=&stock=1&tri=
       (replaceState). ?cat=&sous=&l4= n'est écrit que si l'adresse du menu ne suffit pas (lien hors collection, étiquette
       ambiguë) ; il reste lu. Arrivée ou retour sur /collections/x/Etiquette : tuile, modèle ou niveau 4 présélectionnés.
       Événements : 'bgf:change' (detail = état) puis 'page:loaded' quand la grille JS est redessinée.
       window.BgcomFilterState = l'état courant (kit-inject, bloc-orders).
       ════════════════════════════════════════════════════════════════════════ */
    const CFG0 = window.BgcomFilterCfg || {};
    const app = CFG0.sectionId ? document.getElementById('bgcom-app-' + CFG0.sectionId) : document.querySelector('[id^="bgcom-app-"]');
    if (!app || app.dataset.bgfInit === '1') return;
    app.dataset.bgfInit = '1';

    const CFG = window.BgcomFilterCfg || {};
    const TREE = Array.isArray(window.BgcomMenuTree) ? window.BgcomMenuTree : [];
    const RM = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behav = () => (RM.matches ? 'auto' : 'smooth');
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const SORT_DEFAULT = 'collection-default';
    const SORT_LABEL = { 'title-asc': 'Nom de A à Z', 'title-desc': 'Nom de Z à A', 'price-asc': 'Prix croissant', 'price-desc': 'Prix décroissant' };
    const plural = (n, one, many) => n + ' ' + (n > 1 ? many : one);
    function nounForms(word) {
      word = String(word || 'type').trim() || 'type';
      if (word.indexOf('|') > -1) { const p = word.split('|'); return [p[0].trim(), (p[1] || p[0]).trim()]; }
      return [word, /[sxz]$/i.test(word) ? word : word + 's'];
    }
    const findL2 = t => (t ? TREE.find(n => n.tag === t) : null) || null;
    const findIn = (p, t) => (p && t ? (p.children || []).find(n => n.tag === t) : null) || null;
    /* une étiquette → {l2, l3, l4} : tuile d'abord, puis modèle, puis niveau 4 (même ordre que bgcom-filter-resolve) */
    function resolveTag(t) {
      if (!t) return null;
      for (const a of TREE) { if (!a.empty && a.tag === t) return { l2: a.tag, l3: '', l4: '' }; }
      for (const a of TREE) { if (a.empty) continue; const b = findIn(a, t); if (b && !b.empty) return { l2: a.tag, l3: b.tag, l4: '' }; }
      for (const a of TREE) {
        if (a.empty) continue;
        for (const b of (a.children || [])) { if (b.empty) continue; const c = findIn(b, t); if (c && !c.empty) return { l2: a.tag, l3: b.tag, l4: c.tag }; }
      }
      return null;
    }
    /* adresses : celles du menu, comparées sans casse ni encodage */
    const norm = u => { let x = String(u || ''); try { x = decodeURIComponent(x); } catch (e) {} return x.toLowerCase().replace(/\/+$/, ''); };
    const pathOf = u => { if (!u) return ''; try { return new URL(u, window.location.origin).pathname; } catch (e) { return ''; } };
    /* chemin d'un nœud, seulement s'il est une page étiquette de CETTE collection (sinon ?cat=) */
    function nodePath(n) {
      const p = pathOf(n && n.url);
      if (!p) return '';
      const b = norm(CFG.base || '') + '/';
      const np = norm(p);
      if (b === '/' || np.indexOf(b) !== 0) return '';
      const rest = np.slice(b.length);
      return rest && rest.indexOf('/') === -1 ? p : '';
    }

    const TOTAL_PAGES  = parseInt(CFG.totalPages, 10) || 1;   /* snippets/bgcom-mc-1 (BgcomFilterCfg) : total_pages_count, current_page_num */
    const CURRENT_PAGE = parseInt(CFG.page, 10) || 1;
    const ON_TAG = Array.isArray(CFG.currentTags) && CFG.currentTags.length > 0;
    const INITIAL_PATH = window.location.pathname;
    const INITIAL_URL = window.location.pathname + window.location.search;
    const INITIAL_TITLE = document.title;
    const BASE_PAGES = Math.max(1, parseInt(CFG.basePages, 10) || TOTAL_PAGES);
    /* page étiquette hors menu (/collections/epi-1/cederroth, ou collection sans menu de filtre) : son étiquette reste une
       portée cachée (S.scope) tant qu'aucune tuile n'est choisie ; tri, recherche et stock s'appliquent DANS cette portée,
       sur la même adresse, et « rien d'actif » = la grille serveur de la page (pas de retour à la collection) */
    const SCOPE = (ON_TAG && !resolveTag(CFG.currentTags[0])) ? CFG.currentTags.slice() : [];
    /* paramètres d'adresse gérés ici ; tous les autres (utm_*, gclid, preview_theme_id, bgf=diag…) sont conservés */
    /* 01/10/2026 : sur les pages vendeur / type de Shopify (/collections/vendors?q=…, /collections/types?q=…), q est la clé
       de Shopify (le nom du vendeur), pas une recherche : ni lue comme recherche (puce « Recherche « nom du vendeur » » et
       « Aucun résultat »), ni retirée de l'adresse ; la recherche de la page reste sur place */
    const SHOP_Q = /^\/collections\/(vendors|types)\/?$/.test(window.location.pathname);
    const OUR_KEYS = ['cat', 'sous', 'l4', 'q', 'stock', 'tri', 'page'].filter(k => !(SHOP_Q && k === 'q'));

    const S = { l2: '', l3: '', l4: '', q: '', stock: false, sort: SORT_DEFAULT, scope: false };
    const hasCat = s => !!(s.l2 || s.l3 || s.l4);
    const hasAny = s => hasCat(s) || !!s.q || !!s.stock || s.sort !== SORT_DEFAULT;
    const sameState = (a, b) => ['l2', 'l3', 'l4', 'q', 'stock', 'sort', 'scope'].every(k => a[k] === b[k]);

    /* ── cache des produits (toutes les pages de la collection, dans l'ordre de l'admin : page puis rang) ── */
    let allProductsCache = [];
    const seenIds = new Set();
    let indexed = !ON_TAG && BASE_PAGES <= 1;
    /* degraded : au moins une page n'a pas pu être lue (429, 5xx, délai dépassé, réseau coupé) malgré les nouvelles
       tentatives. Le cache est alors INCOMPLET : aucun compteur par carte, aucune carte ni tuile retirée, jamais
       « 0 résultat » ni l'état vide, un bandeau « Liste incomplète » + « Réessayer », et un choix de catégorie charge la
       page étiquette du serveur (son adresse de menu), qui, elle, est juste. */
    let degraded = false;
    let failedPages = [];
    let retrying = false;
    const ready = () => !!(indexed || isDesignMode);                    /* le passage d'indexation est terminé */
    const complete = () => !!((indexed && !degraded) || isDesignMode);  /* ... et toutes les pages sont là : résultats définitifs */
    const phase = () => (complete() ? 'i' : (ready() ? 'd' : 'p'));
    function thumb(src) { return src ? src.replace(/([?&])width=\d+/, '$1width=240') : ''; }   /* vignettes de 92 à 116 px : 240 pour les écrans 2x */
    function parseCard(card, page, idx) {
      const img = card.querySelector('.bgcom-product-img img');
      return {
        id: card.dataset.productId || '',
        html: card.outerHTML,
        title: card.dataset.title || '',
        allSkus: card.dataset.allSkus || card.dataset.sku || '',
        price: parseFloat(card.dataset.price) || 0,
        stock: card.dataset.stock === 'true',
        tags: (card.dataset.tags || '').split(',').map(t => t.trim()).filter(Boolean),
        img: img ? (img.getAttribute('src') || '') : '',
        page: page,
        idx: idx
      };
    }
    /* page étiquette : sa grille serveur (déjà filtrée) sert de résultats partiels pendant l'indexation ; son rang
       définitif (page, rang dans la collection) est repris quand la page de la collection qui la contient arrive */
    const SEED_PAGE = 1e6;
    function addCard(card, page, idx) {
      const id = card.dataset.productId;
      if (!id) return false;
      if (seenIds.has(id)) {
        if (page < SEED_PAGE) { const it = allProductsCache.find(x => x.id === id); if (it && it.page >= SEED_PAGE) { it.page = page; it.idx = idx; } }
        return false;
      }
      seenIds.add(id);
      allProductsCache.push(parseCard(card, page, idx));
      return true;
    }
    if (originalGrid) {
      originalGrid.querySelectorAll('.bgcom-card-wrap').forEach((c, i) => addCard(c, ON_TAG ? SEED_PAGE : CURRENT_PAGE, i));
    }
    const countFor = tags => {
      if (!complete() || (!indexed && isDesignMode && BASE_PAGES > 1)) return null;
      let n = 0;
      allProductsCache.forEach(it => { if (tags.every(t => it.tags.includes(t))) n++; });
      return n;
    };

    /* une page de la collection (réponse de section) : réponse HTTP vérifiée, délai de 10 s, 2 nouvelles tentatives
       espacées (1 s puis 3 s ; Retry-After respecté jusqu'à 5 s). Une réponse 200 sans la grille (page de contrôle,
       erreur déguisée) compte comme un échec. */
    const FETCH_TIMEOUT = 10000, RETRY_WAIT = [1000, 3000];
    const pause = ms => new Promise(res => setTimeout(res, ms));
    async function fetchPageHTML(n) {
      const url = new URL(window.location.origin + (CFG.base || window.location.pathname));
      url.searchParams.set('page', n);
      url.searchParams.set('section_id', CFG.sectionId);
      let lastErr = null, waitMs = 0;
      for (let attempt = 0; attempt <= RETRY_WAIT.length; attempt++) {
        if (attempt) await pause(waitMs);
        const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = ctrl ? setTimeout(() => ctrl.abort(), FETCH_TIMEOUT) : 0;
        try {
          const resp = await fetch(url.toString(), ctrl ? { credentials: 'same-origin', signal: ctrl.signal } : { credentials: 'same-origin' });
          if (!resp.ok) {
            const err = new Error('HTTP ' + resp.status);
            err.retryAfter = parseFloat(resp.headers.get('Retry-After'));
            throw err;
          }
          const text = await resp.text();
          clearTimeout(timer);
          if (text.indexOf('bgcom-card-wrap') === -1 && text.indexOf('BgcomOriginalGrid') === -1) throw new Error('réponse sans grille');
          return text;
        } catch (err) {
          clearTimeout(timer);
          lastErr = err;
          waitMs = RETRY_WAIT[attempt] || 0;
          if (err && err.retryAfter > 0) waitMs = Math.max(waitMs, Math.min(err.retryAfter * 1000, 5000));
        }
      }
      throw lastErr || new Error('page ' + n);
    }
    function hiddenCache() {
      let hidden = document.getElementById('BgcomHiddenCache');
      if (!hidden) {
        hidden = document.createElement('div');
        hidden.id = 'BgcomHiddenCache';
        hidden.style.cssText = 'position:fixed; top:0; left:0; width:1px; height:1px; opacity:0.001; pointer-events:none; z-index:-9999; overflow:hidden;';
        document.body.appendChild(hidden);
        gridObserver.observe(hidden, { childList: true, subtree: true, characterData: true });
      }
      return hidden;
    }
    function ingestPage(text, n) {
      const hidden = hiddenCache();
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      tmp.querySelectorAll('script').forEach(script => {
        const t = script.textContent || '';
        if (t.includes('initBgcomApp') || t.includes('BgcomMenuTree') || t.includes('BgcomFilterCfg') || t.includes('bgf-pending')) return;
        /* 04/10/2026 (vitesse r5.1) : seulement les scripts en ligne marqués data-bgcom-rerun (aucun aujourd'hui). Avant : tout script
           contenant « Samita » ou « wholesale », c.-à-d. l'aperçu rapide (26 Ko, un commentaire) et BgcomCustomerLoggedIn, recompilés à
           chaque page relue sans rien changer (le renderer Samita est samita-custom, hors de la section). */
        if (!script.src && script.hasAttribute('data-bgcom-rerun')) {
          try { const s2 = document.createElement('script'); s2.textContent = t; document.body.appendChild(s2); setTimeout(() => s2.remove(), 500); } catch (e) {}
        }
      });
      tmp.querySelectorAll('.bgcom-card-wrap').forEach((card, i) => { if (addCard(card, n, i)) hidden.appendChild(card); });
    }
    /* list : pages à (re)lire ; sans argument = toutes les pages de la collection sauf celle déjà dans le DOM */
    async function fetchAllPages(list) {
      const pages = list ? list.slice() : [];
      if (!list) for (let i = 1; i <= BASE_PAGES; i++) { if (ON_TAG || i !== CURRENT_PAGE) pages.push(i); }
      if (!pages.length) { indexed = true; onIndexed(); return; }
      const failed = [];
      let next = 0;
      const worker = async () => {
        while (next < pages.length) {
          const n = pages[next++];
          try { ingestPage(await fetchPageHTML(n), n); } catch (err) { failed.push(n); }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, pages.length) }, worker));
      failedPages = failed.sort((a, b) => a - b);
      degraded = failedPages.length > 0;
      indexed = true;
      document.dispatchEvent(new CustomEvent('page:loaded'));
      onIndexed();
      if (degraded && !list) setTimeout(retryFailed, 8000);   /* une nouvelle passe automatique, puis le bouton « Réessayer » */
    }
    async function retryFailed() {
      if (!degraded || retrying || !failedPages.length) return;
      retrying = true;
      paintPartialNote();
      try { await fetchAllPages(failedPages); } finally { retrying = false; paintPartialNote(); }
    }

    /* ── URL ⇄ état ── */
    const ALL_NODES = [];
    TREE.forEach(a => { ALL_NODES.push(a); (a.children || []).forEach(b => { ALL_NODES.push(b); (b.children || []).forEach(c => ALL_NODES.push(c)); }); });
    /* étiquette portée par le chemin : '' = la collection, null = chemin inconnu du menu */
    function tagFromPath() {
      const cur = norm(window.location.pathname);
      if (cur === norm(CFG.base || '')) return '';
      if (ON_TAG && cur === norm(INITIAL_PATH)) return CFG.currentTags[0] || null;   /* arrivée : l'étiquette lue par Liquid */
      const hit = ALL_NODES.find(n => { const np = nodePath(n); return np && norm(np) === cur; });
      return hit ? hit.tag : null;
    }
    function stateFromURL() {
      const p = new URLSearchParams(window.location.search);
      const s = { l2: '', l3: '', l4: '', q: SHOP_Q ? '' : (p.get('q') || '').trim(), stock: p.get('stock') === '1', sort: SORT_LABEL[p.get('tri')] ? p.get('tri') : SORT_DEFAULT, scope: false };
      if (p.get('cat')) {
        const n2 = findL2(p.get('cat'));
        if (n2 && !n2.empty) {
          s.l2 = n2.tag;
          const n3 = findIn(n2, p.get('sous') || '');
          if (n3 && !n3.empty) {
            s.l3 = n3.tag;
            const n4 = findIn(n3, p.get('l4') || '');
            if (n4 && !n4.empty) s.l4 = n4.tag;
          }
        }
      } else {
        /* /collections/x/Etiquette (arrivée, retour arrière, lien partagé) : tuile, modèle ou niveau 4 présélectionnés */
        const r = resolveTag(tagFromPath());
        if (r) Object.assign(s, r);
      }
      if (SCOPE.length && !hasCat(s) && norm(window.location.pathname) === norm(INITIAL_PATH)) s.scope = true;
      return s;
    }
    function urlFor(s) {
      const p = new URLSearchParams(window.location.search);
      OUR_KEYS.forEach(k => p.delete(k));
      const n2 = findL2(s.l2), n3 = findIn(n2, s.l3), n4 = findIn(n3, s.l4);
      const deep = n4 || n3 || n2;
      let path = s.scope ? INITIAL_PATH : (CFG.base || window.location.pathname);
      if (SHOP_Q) path = path.split('?')[0];   /* base = /collections/vendors?q=… : la clé q reste dans les paramètres conservés */
      if (deep) {
        const np = nodePath(deep);
        const r = np ? resolveTag(deep.tag) : null;
        if (np) path = np;
        if (!r || r.l2 !== (n2 ? n2.tag : '') || r.l3 !== (n3 ? n3.tag : '') || r.l4 !== (n4 ? n4.tag : '')) {
          p.set('cat', n2.tag);
          if (n3) p.set('sous', n3.tag);
          if (n4) p.set('l4', n4.tag);
        }
      }
      if (s.q && !SHOP_Q) p.set('q', s.q);
      if (s.stock) p.set('stock', '1');
      if (s.sort && s.sort !== SORT_DEFAULT) p.set('tri', s.sort);
      if (!hasAny(s) && (!ON_TAG || s.scope) && CURRENT_PAGE > 1) p.set('page', CURRENT_PAGE);
      const qs = p.toString();
      return path + (qs ? '?' + qs : '');
    }
    const hrefOf = (n, fallback) => (n && n.url) || urlFor(fallback);
    /* titre de l'onglet après un changement sur place : même forme que layout/theme.liquid pour une page étiquette
       (« Libellé | Collection | BG COM ») ; l'adresse d'arrivée retrouve le titre d'arrivée */
    function titleFor(s) {
      if (window.location.pathname + window.location.search === INITIAL_URL) return INITIAL_TITLE;
      const n2 = findL2(s.l2), n3 = findIn(n2, s.l3), n4 = findIn(n3, s.l4);
      const deep = n4 || n3 || n2;
      if (deep) return CFG.collTitle ? (deep.seo || deep.title) + ' | ' + CFG.collTitle + ' | BG COM' : null;
      if (s.scope || !ON_TAG) return INITIAL_TITLE;
      return CFG.baseTitle || null;
    }
    function syncTitle() { const t = titleFor(S); if (t && document.title !== t) document.title = t; }

    /* ── éléments ── */
    const filmstrip = document.getElementById('BgcomFilmstrip');
    const arrowsBox = app.querySelector('.bgf-arrows');
    const scrollLeftBtn = document.getElementById('BgcomScrollLeft');
    const scrollRightBtn = document.getElementById('BgcomScrollRight');
    const subNavWrap = document.getElementById('BgcomSubNav');
    const subNavPills = document.getElementById('BgcomSubNavPills');
    const searchInput = document.getElementById('BgcomSearchInput');
    const clearBtn = document.getElementById('BgcomClearBtn');
    const sortSelect = document.getElementById('BgcomSortSelect');
    const stockToggle = document.getElementById('BgcomStockToggle');
    const countLabel = document.getElementById('BgcomCountLabel');
    const activeRow = document.getElementById('BgfActive');
    const chipsList = activeRow ? activeRow.querySelector('.bgf-chips') : null;
    const contextText = document.getElementById('BgcomContextText');
    const viewBtns = app.querySelectorAll('.bgcom-view-btn');
    const tiles = () => Array.prototype.slice.call(app.querySelectorAll('#BgcomFilmstrip .bgcom-film-card[data-tag]'));

    const CHECK = '<span class="bgf-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
    const PH = '<svg class="bgf-ph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>';
    const XICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5.5 5.5l9 9M14.5 5.5l-9 9"/></svg>';
    const SEARCH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>';

    /* ── ATC dans la grille (inchangé) ── */
    const resultsContainer = document.getElementById('BgcomResultsContainer');
    if (resultsContainer && !resultsContainer.dataset.listenerAttached) {
      resultsContainer.addEventListener('submit', async (e) => {
        if (!e.target.classList.contains('bgcom-atc-form')) return;
        e.preventDefault();
        const btn = e.target.querySelector('button');
        const orig = btn.innerText;
        btn.innerText = '...';
        try {
          await fetch('/cart/add.js', { method: 'POST', body: new FormData(e.target) });
          if (window.bgcomRefreshCartCount) { window.bgcomRefreshCartCount(); }
          btn.style.backgroundColor = '#16a34a'; btn.style.color = '#ffffff'; btn.innerText = 'Ajouté !';
          setTimeout(() => { btn.style.backgroundColor = 'var(--bgcom-atc-bg)'; btn.style.color = 'var(--bgcom-atc-txt)'; btn.innerText = orig; }, 2000);
        } catch { btn.innerText = 'Erreur'; }
      });
      resultsContainer.dataset.listenerAttached = "true";
    }

    /* ── image de secours : 1er produit (dans l'ordre de l'admin) qui porte l'étiquette ── */
    function imgFor(node) {
      if (node && node.img) return node.img;
      if (!node || !node.tag || !ready()) return '';
      const hit = allProductsCache.slice().sort((a, b) => (a.page - b.page) || (a.idx - b.idx)).find(it => it.img && it.tags.includes(node.tag));
      return hit ? thumb(hit.img) : '';
    }
    function fillTileImages() {
      tiles().forEach(a => {
        const ph = a.querySelector('.bgcom-film-img > .bgf-ph');
        if (!ph) return;
        const src = imgFor({ tag: a.dataset.tag });
        if (!src) return;
        const img = document.createElement('img');
        img.src = src.replace(/([?&])width=\d+/, '$1width=368'); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
        ph.replaceWith(img);
      });
    }

    /* élément choisi : un clic simple retire ce filtre (l'adresse, elle, reste celle de la page) ; on le dit aux lecteurs d'écran */
    function selHint(a, on) {
      let h = a.querySelector(':scope > .bgf-hint');
      if (on && !h) { h = document.createElement('span'); h.className = 'bgm-sr bgf-hint'; h.textContent = ' (retirer ce filtre)'; a.appendChild(h); }
      else if (!on && h) h.remove();
    }
    /* ── niveau 2 ── */
    function paintTiles() {
      tiles().forEach(a => {   /* l'adresse (href) reste celle du menu : lien lisible par les robots */
        const on = !!S.l2 && a.dataset.tag === S.l2;
        a.classList.toggle('active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        selHint(a, on);
      });
    }

    /* ── niveaux 3 et 4 : cartes horizontales, « Tous les produits » en premier ── */
    /* libellé : coupure permise après une virgule (« Tests (quadrillage,viscosité,…) »), jamais au milieu d'un mot */
    const wbr = t => esc(t).replace(/,(?=\S)/g, ',<wbr>');
    function cardHTML(o) {   /* data-no-instant : le clic est intercepté, instant.page ne précharge pas la page étiquette */
      return '<li><a class="bgcom-l3-card' + (o.empty ? ' is-empty' : '') + '" href="' + esc(o.href) + '" data-no-instant data-tag="' + esc(o.tag) + '" data-title="' + esc(o.title) + '" data-level="' + o.level + '"' + (o.empty ? ' aria-disabled="true" tabindex="-1"' : '') + '>' +
        '<span class="bgcom-l3-card-img-wrap">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" decoding="async">' : PH) + '</span>' +
        '<span class="bgcom-l3-card-content"><span class="bgcom-l3-card-title">' + wbr(o.title) + '</span>' +
        '<span class="bgf-n">' + (o.count == null ? '&nbsp;' : esc(plural(o.count, 'produit', 'produits'))) + '</span>' +
        '<span class="bgf-sel bgcom-l3-badge">Sélectionné</span></span>' + CHECK + '</a></li>';
    }
    let builtL3 = null, builtL4 = null;
    function hideSubNav() {
      if (subNavWrap) subNavWrap.classList.remove('visible', 'is-entering');
      if (subNavPills) subNavPills.innerHTML = '';      /* aucune carte .active ne reste cachée (bug : kit d'une autre catégorie) */
      removeL4();
      builtL3 = null;
    }
    function removeL4() { const r = document.getElementById('BgcomL4Row'); if (r) r.remove(); builtL4 = null; }
    function keptChildren(parentTags, kids, current) {
      return (kids || []).map(c => ({ c: c, k: countFor(parentTags.concat(c.tag)) }))
        .filter(x => isDesignMode || x.c.tag === current || (!x.c.empty && x.k !== 0));
    }
    function renderSubNav(n2) {
      if (!subNavWrap || !subNavPills) return false;
      const kids = keptChildren([n2.tag], n2.children, S.l3);
      if (!kids.length) { hideSubNav(); return false; }
      const f = nounForms(n2.word);
      const wasOpen = subNavWrap.classList.contains('visible');
      const switched = wasOpen && builtL3 && builtL3.split('::')[0] !== n2.tag;
      const focused = document.activeElement && subNavPills.contains(document.activeElement) ? document.activeElement.getAttribute('data-tag') : null;
      document.getElementById('BgcomSubNavEyebrow').textContent = 'Affiner par ' + f[0];
      document.getElementById('BgcomSubNavLabel').textContent = n2.title;
      document.getElementById('BgcomSubNavDesc').textContent = plural(kids.length, f[0], f[1]);
      const base = Object.assign({}, S, { l2: n2.tag, l3: '', l4: '' });
      let html = cardHTML({ tag: '', title: 'Tous les produits', img: imgFor(n2), href: hrefOf(n2, base), level: 3, count: countFor([n2.tag]) });
      kids.forEach(x => {
        html += cardHTML({ tag: x.c.tag, title: x.c.title, img: imgFor(x.c), href: hrefOf(x.c, Object.assign({}, base, { l3: x.c.tag })), level: 3, count: x.k, empty: isDesignMode && (x.c.empty || x.k === 0) });
      });
      subNavPills.innerHTML = html;
      if (!wasOpen || switched) subNavPills.scrollLeft = 0;   /* nouvelle catégorie : la rangée repart du début (« Tous les produits ») */
      subNavWrap.classList.add('visible');
      if (!wasOpen) {
        subNavWrap.classList.add('is-entering');
        subNavWrap.addEventListener('animationend', () => subNavWrap.classList.remove('is-entering'), { once: true });
      } else if (switched) {
        subNavPills.classList.remove('is-swap'); void subNavPills.offsetWidth; subNavPills.classList.add('is-swap');
      }
      if (focused !== null) { const back = subNavPills.querySelector('[data-tag="' + CSS.escape(focused) + '"]'); if (back) back.focus({ preventScroll: true }); }
      return true;
    }
    function renderL4(n3) {
      removeL4();
      const kids = keptChildren([S.l2, n3.tag], n3.children, S.l4);
      if (!kids.length || !subNavPills) return;
      const f = nounForms(n3.word);
      const row = document.createElement('div');
      row.id = 'BgcomL4Row';
      row.className = 'bgf-l4';
      const base = Object.assign({}, S, { l4: '' });
      /* en-tête du niveau 4 : surtitre, NOM du modèle parent (h4), compteur ; la liste porte le même nom */
      let html = '<div class="bgf-l4__head"><p class="bgf-eyebrow">Affiner par ' + esc(f[0]) + '</p><h4 class="bgf-l4__title">' + wbr(n3.title) + '</h4><p class="bgcom-l3-desc">' + esc(plural(kids.length, f[0], f[1])) + '</p></div><ul class="bgcom-l3-grid" role="list" aria-label="' + esc('Affiner par ' + f[0] + ' : ' + n3.title) + '">';
      html += cardHTML({ tag: '', title: 'Tous les produits', img: imgFor(n3), href: hrefOf(n3, base), level: 4, count: countFor([S.l2, n3.tag]) });
      kids.forEach(x => {
        html += cardHTML({ tag: x.c.tag, title: x.c.title, img: imgFor(x.c), href: hrefOf(x.c, Object.assign({}, base, { l4: x.c.tag })), level: 4, count: x.k, empty: isDesignMode && (x.c.empty || x.k === 0) });
      });
      row.innerHTML = html + '</ul>';
      subNavPills.after(row);
    }
    function paintCards(container, level) {
      if (!container) return;
      container.querySelectorAll('a.bgcom-l3-card[data-tag]').forEach(a => {   /* href = adresse du menu, jamais réécrite */
        const t = a.dataset.tag;
        const cur = level === 3 ? S.l3 : S.l4;
        const on = t === cur;
        a.classList.toggle('active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        selHint(a, on && !!t);   /* « Tous les produits » choisi : un clic ne change rien */
      });
    }

    /* ── puces « Filtres actifs » ── */
    function chipList() {
      const out = [];
      const n2 = findL2(S.l2), n3 = findIn(n2, S.l3), n4 = findIn(n3, S.l4);
      const deep = n4 || n3 || n2;
      /* nom accessible : il contient toujours le texte visible de la puce (WCAG 2.5.3) */
      if (deep) out.push({ k: 'cat', label: deep.title, aria: 'Retirer le filtre ' + deep.title });
      if (S.q) out.push({ k: 'q', pre: 'Recherche', label: '« ' + S.q + ' »', aria: 'Recherche « ' + S.q + ' », effacer la recherche' });
      if (S.stock) out.push({ k: 'stock', label: 'En stock', aria: 'Retirer le filtre En stock' });
      if (S.sort !== SORT_DEFAULT) out.push({ k: 'sort', pre: 'Tri :', label: SORT_LABEL[S.sort] || '', aria: 'Tri : ' + (SORT_LABEL[S.sort] || '') + ', revenir au tri par pertinence' });
      return out;
    }
    function paintChips() {
      if (!activeRow || !chipsList) return;
      const want = chipList();
      const keep = {};
      Array.prototype.slice.call(chipsList.children).forEach(li => { keep[li.dataset.sig] = li; });
      const nodes = want.map(c => {
        const sig = c.k + '|' + c.label;
        let li = keep[sig];
        if (li) { delete keep[sig]; return li; }
        li = document.createElement('li');
        li.dataset.sig = sig;
        li.innerHTML = '<button type="button" class="bgf-chip" data-k="' + c.k + '" aria-label="' + esc(c.aria) + '">' + (c.pre ? '<span class="bgf-chip__pre">' + esc(c.pre) + '</span> ' : '') + '<span>' + esc(c.label) + '</span>' + XICON + '</button>';
        return li;
      });
      Object.keys(keep).forEach(k => keep[k].remove());
      nodes.forEach((li, i) => { if (chipsList.children[i] !== li) chipsList.insertBefore(li, chipsList.children[i] || null); });
      activeRow.hidden = want.length === 0;
    }

    /* ── commandes de la barre d'outils ── */
    function paintControls() {
      if (searchInput && document.activeElement !== searchInput && searchInput.value !== S.q) searchInput.value = S.q;
      if (clearBtn) clearBtn.hidden = !(searchInput && searchInput.value);
      if (stockToggle) { stockToggle.classList.toggle('active', S.stock); stockToggle.setAttribute('aria-checked', S.stock ? 'true' : 'false'); }
      if (sortSelect && sortSelect.value !== S.sort) sortSelect.value = S.sort;
      const sw = sortSelect ? sortSelect.closest('.bgf-sort') : null;
      if (sw) sw.toggleAttribute('data-on', S.sort !== SORT_DEFAULT);
    }
    function paintContext() {
      if (!contextText) return;
      const n2 = findL2(S.l2), n3 = findIn(n2, S.l3), n4 = findIn(n3, S.l4);
      /* format lu par l'ancien repli de kit-inject : garder « Sélection en cours : X. » */
      contextText.textContent = (n4 || n3) ? 'Sélection en cours : ' + (n4 || n3).title + '.' : (n2 ? 'Tous les produits de la catégorie ' + n2.title + '.' : '');
    }
    function setCount(n, loading, partial) {
      if (!countLabel) return;
      /* liste incomplète (pages non chargées) : jamais un total présenté comme définitif, jamais « 0 résultat » */
      const t = loading ? 'Chargement des produits…' : (partial ? (n > 0 ? 'Au moins ' + plural(n, 'résultat', 'résultats') : 'Liste incomplète') : plural(n, 'résultat', 'résultats'));
      if (loading) countLabel.setAttribute('aria-busy', 'true'); else countLabel.removeAttribute('aria-busy');
      countLabel.toggleAttribute('data-partial', !!partial && !loading);
      const prev = countLabel.textContent || '';
      if (!loading && !partial && prev && prev.indexOf('Chargement') === -1 && prev.indexOf('incompl') === -1 && prev.indexOf('Au moins') === -1 && window.BGM && typeof window.BGM.odometer === 'function') window.BGM.odometer(countLabel, t);
      else { countLabel.removeAttribute('data-bgm-val'); countLabel.textContent = t; }
      if (resultsContainer) resultsContainer.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    /* ── résultats ── */
    function matches(it) {
      const term = S.q.toLowerCase();
      if (term && !(it.title.includes(term) || it.allSkus.includes(term))) return false;
      if (S.stock && !it.stock) return false;
      if (S.scope && !SCOPE.every(t => it.tags.includes(t))) return false;   /* page étiquette hors menu */
      if (S.l2 && !it.tags.includes(S.l2)) return false;
      if (S.l3 && !it.tags.includes(S.l3)) return false;
      if (S.l4 && !it.tags.includes(S.l4)) return false;
      return true;
    }
    const byNatural = (a, b) => (a.page - b.page) || (a.idx - b.idx);
    function sortItems(list) {
      const v = S.sort;
      return list.sort((a, b) => {
        if (v === 'price-asc') return (a.price - b.price) || byNatural(a, b);
        if (v === 'price-desc') return (b.price - a.price) || byNatural(a, b);
        if (v === 'title-asc') return a.title.localeCompare(b.title, 'fr');
        if (v === 'title-desc') return b.title.localeCompare(a.title, 'fr');
        return byNatural(a, b);
      });
    }
    function emptyHTML() {
      const q = S.q;
      const title = q ? 'Aucun résultat pour « ' + esc(q) + ' »' : 'Aucun produit ne correspond à cette sélection';
      const text = q ? 'Vérifiez la référence ou essayez un mot plus court. La recherche porte sur le nom et toutes les références.' : 'Retirez un filtre ou choisissez une autre catégorie.';
      const btns = '<button type="button" class="bgf-btn" data-bgf-reset>Tout réinitialiser</button>' + (q ? '<button type="button" class="bgf-btn" data-bgf-clear>Effacer la recherche</button>' : '');
      const hx = app.classList.contains('bgf--flat') ? 'p' : 'h3';   /* pas de h3 sans le h2 du filtre (ordre des titres) */
      return '<div class="bgf-empty"><span class="bgf-empty__ic" aria-hidden="true">' + SEARCH_ICON + '</span>' +
        '<' + hx + ' class="bgf-empty__title">' + title + '</' + hx + '><p class="bgf-empty__text">' + text + '</p>' +
        '<div class="bgf-empty__row">' + btns + '<span class="bgf-tel">Une référence introuvable ? <a href="tel:+33426785858">04 26 78 58 58</a></span></div></div>';
    }
    /* bandeau « Liste incomplète » (pages non chargées) : en tête de la grille JS, avec « Réessayer » et, quand une
       catégorie est choisie, le lien vers sa page serveur (adresse du menu), qui est complète */
    function partialNoteHTML() {
      const n2 = findL2(S.l2), n3 = findIn(n2, S.l3), n4 = findIn(n3, S.l4);
      const deep = n4 || n3 || n2;
      const link = deep && deep.url ? '<a class="bgf-link" href="' + esc(deep.url) + '">Afficher la page « ' + esc(deep.title) + ' »</a>' : '';
      return '<div class="bgf-partial" id="BgfPartial" role="note"><p class="bgf-partial__text"><strong>Liste incomplète :</strong> une partie des produits n’a pas pu être chargée. Vérifiez votre connexion puis réessayez.</p>' +
        '<div class="bgf-partial__row"><button type="button" class="bgf-btn" data-bgf-retry' + (retrying ? ' disabled' : '') + '>' + (retrying ? 'Nouvel essai…' : 'Réessayer') + '</button>' + link + '</div></div>';
    }
    function paintPartialNote() {
      const note = document.getElementById('BgfPartial');
      if (!note) return;
      const b = note.querySelector('[data-bgf-retry]');
      if (b) { b.disabled = retrying; b.textContent = retrying ? 'Nouvel essai…' : 'Réessayer'; }
    }
    /* la grille serveur de la page est-elle exactement la vue demandée ? (page étiquette d'arrivée, sans recherche, stock ni tri) */
    function serverView(s) {
      if (!ON_TAG || s.q || s.stock || s.sort !== SORT_DEFAULT) return false;
      if (norm(window.location.pathname) !== norm(INITIAL_PATH)) return false;
      if (s.scope) return true;
      return CFG.currentTags.length === 1 && (s.l4 || s.l3 || s.l2) === CFG.currentTags[0];
    }
    function showServerGrid(origGrid, srchGrid, pag) {
      origGrid.style.display = '';
      srchGrid.style.display = 'none';
      srchGrid.innerHTML = '';
      if (pag) pag.style.display = '';
      app.removeAttribute('data-bgf-busy');
      setCount(parseInt(CFG.total, 10) || origGrid.querySelectorAll('.bgcom-card-wrap').length, false);
    }
    function renderResults(fromUser) {
      const origGrid = document.getElementById('BgcomOriginalGrid');
      const srchGrid = document.getElementById('BgcomSearchGrid');
      const pag = document.getElementById('BgcomPaginationWrap');
      if (!origGrid || !srchGrid) return;
      if (!hasAny(S)) {
        /* la grille serveur d'une page étiquette du menu est un sous-ensemble : sans filtre, on revient à la collection ;
           une page étiquette hors menu (portée) garde sa propre grille */
        if (ON_TAG && !S.scope && fromUser) { window.location.assign(urlFor(S)); return; }
        showServerGrid(origGrid, srchGrid, pag);
        return;
      }
      if (degraded && serverView(S)) { showServerGrid(origGrid, srchGrid, pag); return; }
      const list = sortItems(allProductsCache.filter(matches));
      origGrid.style.display = 'none';
      srchGrid.style.display = '';
      if (pag) pag.style.display = 'none';
      const partial = ready() && !complete();
      srchGrid.innerHTML = (list.length === 0 && complete()) ? emptyHTML() : (partial ? partialNoteHTML() : '') + list.map(r => r.html).join('');
      if (ready()) app.removeAttribute('data-bgf-busy'); else app.setAttribute('data-bgf-busy', '');
      setCount(list.length, !ready(), partial);
      document.dispatchEvent(new CustomEvent('page:loaded'));
      window.dispatchEvent(new Event('resize'));
      setTimeout(() => processSamitaBadges(false), 50);
    }

    /* ── rendu complet ── */
    function render(fromUser, quiet) {   /* quiet : re-rendu après indexation, sans toucher au défilement des rangées */
      const n2 = findL2(S.l2);
      const n3 = findIn(n2, S.l3);
      /* ready = résultats définitifs (toutes les pages lues) ; indexed = passage terminé ; degraded = des pages manquent */
      window.BgcomFilterState = { l2: S.l2, l3: S.l3, l4: S.l4, q: S.q, stock: S.stock, sort: S.sort, deepest: S.l4 || S.l3 || S.l2 || '', ready: complete(), indexed: ready(), degraded: degraded, scope: S.scope ? SCOPE.slice() : [] };
      paintTiles();
      let l3Open = false;
      if (n2 && (n2.children || []).length) {
        const key = n2.tag + '::' + phase();
        if (builtL3 !== key) { l3Open = renderSubNav(n2); if (l3Open) builtL3 = key; }
        else l3Open = true;
        if (l3Open) paintCards(subNavPills, 3);
      } else if (builtL3 !== null || (subNavWrap && subNavWrap.classList.contains('visible'))) {
        hideSubNav();
      }
      if (l3Open && n3 && (n3.children || []).length) {
        const key4 = S.l2 + '>' + n3.tag + '::' + phase();
        if (builtL4 !== key4) { renderL4(n3); builtL4 = document.getElementById('BgcomL4Row') ? key4 : null; }
        paintCards(document.getElementById('BgcomL4Row'), 4);
      } else {
        removeL4();
      }
      paintControls();
      paintChips();
      paintContext();
      renderResults(fromUser);
      app.removeAttribute('data-bgf-pending');
      if (!fromUser && !quiet) revealSelection();
      document.dispatchEvent(new CustomEvent('bgf:change', { detail: window.BgcomFilterState }));
    }

    /* ── défilement horizontal de la rangée + flèches ── */
    const ROW_PAD = 4;
    function updArrows() {
      if (!filmstrip || !arrowsBox) return;
      const max = filmstrip.scrollWidth - filmstrip.clientWidth;
      const show = max > ROW_PAD + 2 && window.matchMedia('(min-width: 768px)').matches;
      arrowsBox.hidden = !show;
      if (!show) return;
      const sl = filmstrip.scrollLeft;
      const want = [[scrollLeftBtn, sl <= ROW_PAD + 2], [scrollRightBtn, sl >= max - ROW_PAD - 2]];
      want.forEach(([b, dis]) => { if (b && !dis) b.disabled = false; });
      want.forEach(([b, dis]) => {
        if (!b || !dis || b.disabled) return;
        if (document.activeElement === b) { const other = b === scrollLeftBtn ? scrollRightBtn : scrollLeftBtn; if (other && !other.disabled) other.focus({ preventScroll: true }); }
        b.disabled = true;
      });
    }
    let arrowRaf = 0;
    const queueArrows = () => { if (!arrowRaf) arrowRaf = requestAnimationFrame(() => { arrowRaf = 0; updArrows(); }); };
    function stripStep() {
      const li = filmstrip ? filmstrip.querySelector('li') : null;
      return Math.max(filmstrip.clientWidth - (li ? li.offsetWidth + 12 : 0), 200);
    }
    if (filmstrip) {
      filmstrip.addEventListener('scroll', queueArrows, { passive: true });
      if (scrollLeftBtn) scrollLeftBtn.addEventListener('click', () => filmstrip.scrollBy({ left: -stripStep(), behavior: behav() }));
      if (scrollRightBtn) scrollRightBtn.addEventListener('click', () => filmstrip.scrollBy({ left: stripStep(), behavior: behav() }));
      if (window.__bgfResize) window.removeEventListener('resize', window.__bgfResize);
      window.__bgfResize = queueArrows;
      window.addEventListener('resize', queueArrows);
      window.addEventListener('load', queueArrows);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueArrows);
    }
    /* fait entrer un élément coupé dans sa rangée horizontale (tuiles, ou cartes modèles sur téléphone), sans recentrer */
    function revealIn(row, a, instant) {
      if (!row || !a || row.scrollWidth <= row.clientWidth + 1) return;
      const li = a.closest('li') || a;
      const r = li.getBoundingClientRect(), s = row.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
      let dx = 0;
      if (r.left < s.left + pad) dx = r.left - s.left - pad;
      else if (r.right > s.right - pad) dx = r.right - s.right + pad;
      if (dx) row.scrollBy({ left: dx, behavior: instant ? 'auto' : behav() });
    }
    function revealTile(a) { revealIn(filmstrip, a, false); }
    /* arrivée, retour arrière : la tuile et les cartes choisies sont visibles dans leur rangée */
    function revealSelection() {
      revealIn(filmstrip, filmstrip ? filmstrip.querySelector('a.bgcom-film-card[aria-current="true"]') : null, true);
      revealIn(subNavPills, subNavPills ? subNavPills.querySelector('a.bgcom-l3-card[aria-current="true"]') : null, true);
      const l4 = document.getElementById('BgcomL4Row');
      if (l4) revealIn(l4.querySelector('.bgcom-l3-grid'), l4.querySelector('a.bgcom-l3-card[aria-current="true"]'), true);
    }

    /* bloc qui vient de s'ouvrir (« Affiner par … », niveau 4) sous la ligne de flottaison : défilement JUSTE suffisant
       pour le montrer en entier (bas à 16 px du bord), sans jamais faire passer la rangée du dessus (keep) sous l'en-tête
       collant (décision du lead, 30/09, prime sur « un niveau 2 avec modèles ne défile jamais ») */
    function revealBlock(block, keep) {
      if (!block || !block.getClientRects().length) return;
      const hdr = document.querySelector('.header-section');
      const hb = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      const lift = block.classList.contains('is-entering') ? 8 : 0;   /* entrée animée : le bloc part 8 px plus bas */
      const need = block.getBoundingClientRect().bottom - lift - (window.innerHeight - 16);
      if (need <= 0) return;
      const room = keep ? keep.getBoundingClientRect().top - hb - 12 : need;
      const dy = Math.min(need, Math.max(0, room));
      if (dy > 1) window.scrollBy({ top: dy, behavior: behav() });
    }
    /* carte modèle ou niveau 4 touchée alors qu'elle dépasse de sa rangée (téléphone) : elle y entre, sans recentrage */
    function revealCard(origin, el) {
      const row = origin === 'l3' ? subNavPills : document.querySelector('#BgcomL4Row .bgcom-l3-grid');
      if (!row || !el) return;
      const a = row.querySelector('a.bgcom-l3-card[data-tag="' + CSS.escape(el.dataset.tag || '') + '"]');
      if (a) revealIn(row, a, false);
    }
    /* ── défilement de la page après un clic : seulement si les résultats sont sous la ligne de flottaison ── */
    function afterClick(origin, el) {
      if (origin === 'l2' && el) revealTile(el);
      if (origin === 'l2' && subNavWrap && subNavWrap.classList.contains('visible')) { revealBlock(subNavWrap, filmstrip); return; }
      if (origin === 'l3' || origin === 'l4') revealCard(origin, el);
      if (origin === 'l3' && S.l3) { const l4 = document.getElementById('BgcomL4Row'); if (l4) { revealBlock(l4, subNavPills); return; } }
      if (['l2', 'l3', 'l4', 'chip'].indexOf(origin) === -1) return;
      if (!resultsContainer) return;
      if (resultsContainer.getBoundingClientRect().top <= window.innerHeight - 120) return;
      const anchor = (activeRow && !activeRow.hidden) ? activeRow : document.getElementById('BgcomControlBoard');
      if (!anchor) return;
      const hdr = document.querySelector('.header-section');
      const hb = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      window.scrollTo({ top: Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - hb - 12), behavior: behav() });
    }

    /* ── changement d'état ── */
    function commit(patch, o) {
      o = o || {};
      const before = JSON.stringify(S);
      const catBefore = S.l2 + '>' + S.l3 + '>' + S.l4;
      Object.assign(S, patch);
      if (JSON.stringify(S) === before) return;   /* rien ne change (ex. « Tous les produits » déjà choisi) */
      if (!hasAny(S) && ON_TAG && !S.scope) { window.location.assign(urlFor(S)); return; }
      const url = urlFor(S);
      /* liste incomplète : un changement de catégorie charge la page du serveur (adresse du menu), qui est complète */
      if (degraded && hasCat(S) && (S.l2 + '>' + S.l3 + '>' + S.l4) !== catBefore) { window.location.assign(url); return; }
      try {
        if (o.push) window.history.pushState({ bgf: 1 }, '', url);
        else window.history.replaceState({ bgf: 1 }, '', url);
      } catch (e) {}
      syncTitle();
      render(true);
      if (o.origin) afterClick(o.origin, o.el);
    }
    function resetAll() {
      if (searchInput) searchInput.value = '';
      /* page étiquette hors menu : sa portée n'est pas un filtre affiché, elle reste (retour à la grille de la page) */
      commit({ l2: '', l3: '', l4: '', q: '', stock: false, sort: SORT_DEFAULT, scope: S.scope && !hasCat(S) }, { push: true });
    }
    function focusAfterRemoval(idx) {
      if (activeRow && !activeRow.hidden) {
        const chips = activeRow.querySelectorAll('.bgf-chip');
        const target = chips[Math.min(idx, chips.length - 1)] || document.getElementById('BgcomResetFilters');
        if (target) target.focus({ preventScroll: true });
      } else if (countLabel) {
        countLabel.focus({ preventScroll: true });
      }
    }
    function removeChip(btn) {
      const k = btn.dataset.k;
      const hadFocus = document.activeElement === btn;
      const idx = Array.prototype.indexOf.call(chipsList.querySelectorAll('.bgf-chip'), btn);
      if (k === 'cat') {
        if (S.l4) commit({ l4: '' }, { push: true, origin: 'chip' });
        else if (S.l3) commit({ l3: '', l4: '' }, { push: true, origin: 'chip' });
        else commit({ l2: '', l3: '', l4: '' }, { push: true, origin: 'chip' });
      } else if (k === 'q') {
        if (searchInput) searchInput.value = '';
        commit({ q: '' });
      } else if (k === 'stock') {
        commit({ stock: false });
      } else if (k === 'sort') {
        commit({ sort: SORT_DEFAULT });
      }
      if (hadFocus) focusAfterRemoval(idx);
    }

    app.addEventListener('click', (e) => {
      const a = e.target.closest('a.bgcom-film-card[data-tag], a.bgcom-l3-card[data-tag]');
      if (a && app.contains(a)) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   /* nouvel onglet, etc. : le lien fait son travail */
        e.preventDefault();
        if (a.getAttribute('aria-disabled') === 'true') return;
        const t = a.dataset.tag || '';
        if (a.classList.contains('bgcom-film-card')) {
          commit(S.l2 === t ? { l2: '', l3: '', l4: '' } : { l2: t, l3: '', l4: '', scope: false }, { push: true, origin: 'l2', el: a });
        } else if (a.dataset.level === '4') {
          commit({ l4: S.l4 === t ? '' : t }, { push: true, origin: 'l4', el: a });
        } else {
          commit({ l3: S.l3 === t ? '' : t, l4: '' }, { push: true, origin: 'l3', el: a });
        }
        return;
      }
      const chip = e.target.closest('.bgf-chip[data-k]');
      if (chip && app.contains(chip)) { removeChip(chip); return; }
      const reset = e.target.closest('#BgcomResetFilters, [data-bgf-reset]');
      if (reset && app.contains(reset)) {
        const hadFocus = document.activeElement === reset;
        resetAll();
        if (hadFocus && countLabel) countLabel.focus({ preventScroll: true });
        return;
      }
      const clr = e.target.closest('[data-bgf-clear]');
      if (clr && app.contains(clr)) { if (searchInput) searchInput.value = ''; commit({ q: '' }); if (searchInput) searchInput.focus({ preventScroll: true }); return; }
      const rt = e.target.closest('[data-bgf-retry]');
      if (rt && app.contains(rt)) retryFailed();
    });

    let searchTimer;
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        if (clearBtn) clearBtn.hidden = !searchInput.value;
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => commit({ q: searchInput.value.trim() }), 280);
      });
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(searchTimer); commit({ q: searchInput.value.trim() }); }
        else if (e.key === 'Escape' && searchInput.value) { e.preventDefault(); searchInput.value = ''; clearTimeout(searchTimer); commit({ q: '' }); }
      });
    }
    if (clearBtn) clearBtn.addEventListener('click', () => { if (searchInput) { searchInput.value = ''; searchInput.focus({ preventScroll: true }); } clearTimeout(searchTimer); commit({ q: '' }); });
    if (sortSelect) sortSelect.addEventListener('change', () => commit({ sort: sortSelect.value || SORT_DEFAULT }));
    if (stockToggle) stockToggle.addEventListener('click', () => commit({ stock: !S.stock }));
    viewBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        viewBtns.forEach(b => { b.classList.toggle('active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        const isList = btn.dataset.view === 'list';
        if (originalGrid) originalGrid.classList.toggle('list-view', isList);
        if (searchGrid) searchGrid.classList.toggle('list-view', isList);
      });
    });

    if (window.__bgfPop) window.removeEventListener('popstate', window.__bgfPop);
    window.__bgfPop = () => {
      const next = stateFromURL();
      if (sameState(next, S)) { syncTitle(); return; }   /* ancre de la page (#MainContent, préférences cookies…) : rien n'est redessiné */
      Object.assign(S, next);
      if (searchInput) searchInput.value = S.q;
      syncTitle();
      render(false);
    };
    window.addEventListener('popstate', window.__bgfPop);

    /* ── contrôle (éditeur de thème, ou ?bgf=diag) : produits sans catégorie, modèles vides après croisement ── */
    function health() {
      const box = document.getElementById('BgfHealth');
      if (!box) return;
      const diag = isDesignMode || new URLSearchParams(window.location.search).get('bgf') === 'diag';
      if (!diag) return;
      /* r5.2 : hors éditeur, le contenu est dans <template id="BgfHealthTpl"> (pas dans la page indexée) */
      const tpl = document.getElementById('BgfHealthTpl');
      if (tpl && !box.firstElementChild) { box.appendChild(tpl.content.cloneNode(true)); tpl.remove(); }
      box.hidden = false;
      const ul = box.querySelector('ul');
      if (!ul) return;
      ul.querySelectorAll('li[data-js]').forEach(li => li.remove());
      const add = (html) => { const li = document.createElement('li'); li.dataset.js = '1'; li.innerHTML = html; ul.appendChild(li); };
      if (!indexed) {
        if (BASE_PAGES > 1) add('Comptage des produits sans catégorie : ouvrez la page de la boutique avec ?bgf=diag à la fin de l’adresse (l’éditeur ne charge que la page 1).');
        return;
      }
      if (degraded) add('Pages du catalogue non chargées : ' + esc(failedPages.join(', ')) + ' (sur ' + esc(BASE_PAGES) + '). Les compteurs sont masqués et les chiffres ci-dessous sont partiels.');
      const l2tags = TREE.filter(n => !n.empty).map(n => n.tag);
      if (l2tags.length) {
        const orphans = allProductsCache.filter(it => !l2tags.some(t => it.tags.includes(t)));
        if (orphans.length) add(esc(orphans.length) + ' produits sur ' + esc(allProductsCache.length) + ' ne sont dans aucune catégorie (exemples : ' + orphans.slice(0, 5).map(o => '« ' + esc(o.title) + ' »').join(', ') + ').');
      }
      TREE.forEach(n2 => (n2.children || []).forEach(n3 => {
        if (n3.empty) return;
        if (countFor([n2.tag, n3.tag]) === 0) add('Modèle masqué : aucun produit ne porte à la fois « ' + esc(n2.tag) + ' » et « ' + esc(n3.tag) + ' » (' + esc(n3.title) + '). Ajoutez l’étiquette de la catégorie à ces produits.');
      }));
      if (!ul.children.length) add('Rien à signaler.');
    }
    /* all_tags vide (robots, ou collection sans étiquette) : Liquid n'a pas pu masquer les tuiles sans produit ; on le fait
       une fois tout indexé (jamais dans l'éditeur, jamais la tuile choisie) */
    function hideEmptyTiles() {
      if (isDesignMode || app.getAttribute('data-bgf-tagcount') !== '0' || !indexed) return;
      tiles().forEach(a => { const li = a.closest('li'); if (li && a.dataset.tag !== S.l2 && countFor([a.dataset.tag]) === 0) li.hidden = true; });
      queueArrows();
    }
    function onIndexed() { fillTileImages(); hideEmptyTiles(); render(false, true); health(); restoreY(); }

    /* ── retour depuis une fiche produit : la page est rechargée et la grille JS n'a d'abord qu'une partie des produits ;
       la position de lecture (gardée au départ, par adresse) est rendue une fois le passage d'indexation terminé.
       Seulement pour un retour arrière, sur une vue filtrée, tant que le visiteur n'a pas défilé lui-même. ── */
    const Y_KEY = 'bgfY:' + window.location.pathname + window.location.search;
    let pendingY = null;
    function saveY() {
      if (!hasAny(S)) return;
      try { window.sessionStorage.setItem('bgfY:' + window.location.pathname + window.location.search, String(Math.round(window.scrollY))); } catch (e) {}
    }
    function dropY() {
      if (pendingY === null) return;
      pendingY = null;
      try { window.history.scrollRestoration = 'auto'; } catch (e) {}
    }
    function restoreY() {
      if (pendingY === null || !ready()) return;
      const y = pendingY;
      dropY();
      window.scrollTo(0, y);
    }
    if (!app.dataset.bgfY) {
      app.dataset.bgfY = '1';
      document.addEventListener('click', e => { if (e.target.closest && e.target.closest('#BgcomResultsContainer a[href]')) saveY(); }, true);
      window.addEventListener('pagehide', saveY);
    }

    /* ── démarrage ── */
    Object.assign(S, stateFromURL());
    if (searchInput) searchInput.value = S.q;
    try {
      const nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      const y = parseInt(window.sessionStorage.getItem(Y_KEY), 10);
      window.sessionStorage.removeItem(Y_KEY);
      if (nav && nav.type === 'back_forward' && y > 0 && hasAny(S) && !ready()) {
        pendingY = y;
        window.history.scrollRestoration = 'manual';
        ['wheel', 'touchstart', 'keydown'].forEach(ev => window.addEventListener(ev, dropY, { once: true, passive: true }));
      }
    } catch (e) {}
    render(false);
    if (pendingY !== null) window.scrollTo(0, pendingY);   /* au plus près tout de suite, exact après l'indexation */
    updArrows();
    setTimeout(updArrows, 300);
    if (indexed) { fillTileImages(); hideEmptyTiles(); health(); }
    else if (!isDesignMode) {
      /* 04/10/2026 (vitesse r5.1) : filtre / recherche / tri dans l'adresse = relecture immédiate (inchangé). Sinon, la relecture des
         autres pages de la collection (jusqu'à 150 Ko) ne part plus 300 ms après DOMContentLoaded, en pleine fenêtre LCP, mais au 1er
         geste dans le catalogue (pointeur, toucher, clavier, focus, survol) ou au repos après « load » (2 s au plus). */
      if (hasAny(S)) setTimeout(() => fetchAllPages(), 0);
      else {
        let started = false;
        const EV = ['pointerdown', 'touchstart', 'keydown', 'focusin', 'mouseover'];
        const go = () => { if (started) return; started = true; EV.forEach(ev => app.removeEventListener(ev, go, true)); fetchAllPages(); };
        EV.forEach(ev => app.addEventListener(ev, go, { capture: true, passive: true }));
        const idle = () => { if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 200); };
        if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
      }
    }
    else { health(); }
  }

  // Shopify Editor Safeties
  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBgcomApp);
  } else {
      initBgcomApp();
  }

  document.addEventListener('shopify:section:load', function(event) {
      if (event.detail && event.detail.sectionId === (window.BgcomFilterCfg || {}).sectionId) {
          initBgcomApp();
      }
  });

})();
